import { render, staticRenderFns } from "./LegalEntityInformation.vue?vue&type=template&id=149beb53"
import script from "./LegalEntityInformation.vue?vue&type=script&lang=js"
export * from "./LegalEntityInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports